export default class EntrepriseDto {
  id;
  libelle;
  siret;
  siren;
  adresseSiren;
  villeSiren;
  villeSirenAutre;
  paysSiren;
  adresseSiret;
  villeSiret;
  villeSiretAutre;
  paysSiret;
  ess;
  createdDate;
}